import isHexColor from './is-hex-color';
// Make sure color channel value fits in range between 0 and 255
function clampColorChannel(value) {
    return Math.max(Math.min(255, value), 0).toString(16);
}
/**
 * Make HEX color darker or lighter
 *
 * @param hexColor HEX color code, starts with hash followed by either 3 or 6 digits
 * @param amount To lighten color provide value in range between 0 and 1 (where 1 is pure white), and to darken in range from 0 to -1 (where -1 is pitch black)
 * @returns HEX color code
 */
function hexColorShade(hexColor, amount) {
    if (!isHexColor(hexColor)) {
        throw new Error("Couldn't parse the color string. Please provide the color as a string in HEX notation.");
    }
    if (amount < -1 || amount > 1) {
        throw new Error('Invalid amount value. Please provide a value in range between -1 and 1.');
    }
    var normalizedAmount = Math.trunc(255 * amount);
    var colorCode = hexColor.slice(1); // remove hash
    var group = colorCode.length / 3;
    return "#".concat([0, 1, 2]
        .map(function (index) {
        return colorCode.slice(index * group, (index + 1) * group);
    })
        .map(function (value) {
        return parseInt((value + value).slice(-2), 16) + normalizedAmount;
    })
        .map(function (adjustedValue) {
        return clampColorChannel(adjustedValue).padStart(2, '0').toUpperCase();
    })
        .join(''));
}
export default hexColorShade;
